import {useEffect, useState} from 'react';
import useTabId from '../../../utils/useTabId';
import AiAssistantChatbotStore from '../store/AiAssistantChatbotStore';
import NavigationStore from '../../../navigation/store/NavigationStore';
import {AiAssitantChatMessage} from '../../../data/models/AI/AiAssistantModels';

export function useWidgetChatbot(
  store: AiAssistantChatbotStore | undefined,
  navigationStore: NavigationStore | undefined,
) {
  const [chat, setChat] = useState<AiAssitantChatMessage[]>([]);
  const [title, setTitle] = useState('');
  const [avatar, setAvatar] = useState('');
  const tabId = useTabId();
  const orgId = navigationStore?.userOrganization?.id ?? '';

  useEffect(() => {
    if (store?.shouldShowChatbot && orgId && store.currentAssistant) {
      store.getAssistantChat(orgId, store.currentAssistant).then(res => {
        if (res) {
          setChat(res.history.chat_history);
          setTitle(res.title);
          setAvatar(res.avatarUrl ?? '');
        }
      });
    } else {
      setChat([]);
    }
  }, [store?.shouldShowChatbot, store?.currentAssistant]);

  const sendMessage = async (message: string) => {
    if (!store || !orgId) return;
    const newMessage = {
      learner_question: message,
      assistant_response: '',
      created_on: '',
    };
    setChat(prevChat => [...prevChat, newMessage]);

    let streamedResponse = '';

    await store.sendMessageStream(
      orgId,
      '',
      message,
      (chunk: string) => {
        streamedResponse += chunk;
        setChat(prevChat => {
          const updatedChat = [...prevChat];
          if (updatedChat.length > 0) {
            updatedChat[updatedChat.length - 1] = {
              ...updatedChat[updatedChat.length - 1],
              assistant_response: streamedResponse,
            };
          }
          return updatedChat;
        });
      },
      () => {
        // Stream complete
      },
      false,
    );
  };

  const clearChat = async () => {
    if (store) {
      const success = await store.clearAssistantChat('');
      if (success && store.currentAssistant) {
        const res = await store.getAssistantChat(orgId, store.currentAssistant);
        if (res) {
          setChat(res.history.chat_history);
          setTitle(res.title);
          setAvatar(res.avatarUrl ?? '');
        }
      }
    }
  };

  return {chat, title, assistantAvatar: avatar, sendMessage, clearChat, tabId};
}
